import * as React from 'react';
import { Input } from 'antd';
import { InputProps } from 'antd/es/input';

type NumericInputProps = {
  decimal?: boolean;
};

const NumericInput = (props: NumericInputProps & InputProps) => {
  const { decimal, onChange } = props;

  const checkValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    const regex = decimal ? /^-?[\d,]*?$/ : /^-?[\d,]*(\.\d*)?$/;
    if (onChange && regex.test(value)) {
      onChange(event);
    }
  };

  return <Input {...props} onChange={checkValue} />;
};

NumericInput.defaultProps = {
  decimal: false,
};

export default NumericInput;
